// extracted by mini-css-extract-plugin
module.exports = {"Awards":"Awards-module--Awards--NTRrO"};